import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import { Card, CardHeader, CardContent, Typography, Box, Avatar, Button } from "@mui/material";
import { red } from "@mui/material/colors";
import axios from "axios";
import { TableLoader } from "../components/ContentLoader";
import { authData } from "../components/GetAuth";

const TodayRequestList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/driver/request-list-not-picked", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    }

    fetchData();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;
    setFilteredData(filterredTempData);
  }, [allData]);

  return (<div className={`${styles.MainDiv}`}>
    <div className={`${styles.PageTitleWrap}`}>
      <p className={`${styles.PageTitle}`}>Request List</p>
    </div>

    <div className={`${styles.MainCard}`}>
      {contentLoading && <TableLoader />}

      {filteredData.map((item, index) => {
        return (<Box sx={{ minWidth: 275 }}>
          <RouterLink as={Button} to={"/driver/address-details/" + item?.id}>
            <Card variant="outlined" key={item?.id}>
              <CardHeader avatar={<Avatar sx={{ bgcolor: red[200] }} aria-label="recipe">{item?.no_of_items}</Avatar>} />

              <CardContent>
                <Typography variant="h5" component="div">{item?.customer_name}</Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">{item?.pickup_details?.address}</Typography>
                <Typography variant="body2">{item?.booking_date}</Typography>
              </CardContent>
            </Card>
          </RouterLink>
        </Box>);
      })}
    </div>
  </div>);
}

export default TodayRequestList;